import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { PageHeader } from 'axway-react-ui';
import { Button, Col, Grid, Row } from 'react-bootstrap';

class SummaryView extends React.Component {
	constructor(props) {
		super(props);
		this.toggleApiKeyVisibility = this.toggleApiKeyVisibility.bind(this);
		this.state = {
			apikeyVisible: false
		};
		IntlComponent.init(this);
	}

	toggleApiKeyVisibility(e) {
		e && e.preventDefault();
		this.setState({
			...this.state,
			apikeyVisible: !this.state.apikeyVisible
		});
	}

	render() {
		const { project } = this.props;
		const { apikeyVisible } = this.state;
		return (
			<div className="summarypage ux-container">
				<PageHeader>
					<PageHeader.Section align="left">
						<PageHeader.Title
							infoPopover={{
								id: 'api-builder-info',
								description: this.intl.formatMsg('API Builder lets you build and deploy a project that is comprised of API endpoints that can be consumed by any client application.'),
								docLink: window.$conf.docSummaryUrl
							}}
						>
							{this.intl.formatMsg('Summary')}
						</PageHeader.Title>
					</PageHeader.Section>
				</PageHeader>

				<Grid fluid className="ux-container">
					<Row>
						<Col sm={5}>
							<Grid fluid>
								<Row className="field name">
									<Col sm={4}>
										<span className="key">{this.intl.formatMsg('Name')}</span>
									</Col>
									<Col sm={8}>
										<span className="value">{project.name}</span>
									</Col>
								</Row>
								<Row className="field version">
									<Col sm={4}>
										<span className="key">{this.intl.formatMsg('Version')}</span>
									</Col>
									<Col sm={8}>
										<span className="value">{project.version}</span>
									</Col>
								</Row>
								<Row className="field description">
									<Col sm={4}>
										<span className="key">{this.intl.formatMsg('Description')}</span>
									</Col>
									<Col sm={8}>
										<span className="value wraps">
											{project.description}
										</span>
									</Col>
								</Row>
							</Grid>
						</Col>
						<Col sm={5}>
							<Grid fluid>
								<Row className="field author">
									<Col sm={4}>
										<span className="key">{this.intl.formatMsg('Author')}</span>
									</Col>
									<Col sm={8}>
										<span className="value">{project.author}</span>
									</Col>
								</Row>
								<Row className="field license">
									<Col sm={4}>
										<span className="key">{this.intl.formatMsg('License')}</span>
									</Col>
									<Col sm={8}>
										<span className="value wraps">{project.license}</span>
									</Col>
								</Row>
								<Row className="field apikey">
									<Col sm={4}>
										<span className="key">{this.intl.formatMsg('API Key')}</span>
									</Col>
									<Col sm={8}>

										<Button
											className="text ux-item-spacing-l-right"
											onClick={this.toggleApiKeyVisibility}
										>
											{apikeyVisible ? this.intl.formatMsg('Hide') : this.intl.formatMsg('Show')}
										</Button>

										<span className="value" aria-hidden={!apikeyVisible} aria-live="assertive">
											{apikeyVisible ? project.apikey : this.intl.formatMsg('••••••••••••••••••••••••', 'obfuscated_secret')}
										</span>
									</Col>
								</Row>
							</Grid>
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}

SummaryView.propTypes = {
	project: PropTypes.object.isRequired
};

export default injectIntl(SummaryView);
